import { User, Calendar, Target, Folder, SquareCheck, Sparkles } from 'lucide-react';
import type {
  IConversation,
  IMessage,
  IContactDetail,
  IContactTag,
  IIconSidebarItem,
  IMessageChannelOption,
} from '@/@types/messages';

// ============================================================================
// Channel Configuration
// ============================================================================

export const MESSAGE_CHANNELS: IMessageChannelOption[] = [
  { value: 'sms', label: 'SMS' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'Email' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'telegram', label: 'Telegram' },
];

// ============================================================================
// Icon Sidebar Items
// ============================================================================

export const ICON_SIDEBAR_ITEMS: IIconSidebarItem[] = [
  { id: 'contact', icon: User, label: 'Contact Details' },
  { id: 'calendar', icon: Calendar, label: 'Calendar' },
  { id: 'opportunity', icon: Target, label: 'Opportunity' },
  { id: 'documents', icon: Folder, label: 'Documents' },
  { id: 'tasks', icon: SquareCheck, label: 'Tasks' },
  { id: 'ai', icon: Sparkles, label: 'AI Automation' },
];

// ============================================================================
// Mock Conversations
// ============================================================================

export const MOCK_CONVERSATIONS: IConversation[] = [
  {
    id: 'conv-1',
    contactName: 'Keven Text',
    contactInitials: 'KT',
    avatarColor: '#B8EF70',
    lastMessage: 'Absolutely! Before we set up a tour...',
    lastMessageTime: '4:32 PM',
    unreadCount: 2,
    isStarred: false,
    channel: 'sms',
    isActive: true,
  },
  {
    id: 'conv-2',
    contactName: 'Michael Howard',
    contactInitials: 'MH',
    avatarColor: '#0D9488',
    lastMessage: 'Sorry I missed your call Michael!...',
    lastMessageTime: 'Jun 04',
    unreadCount: 0,
    isStarred: false,
    channel: 'whatsapp',
  },
  {
    id: 'conv-3',
    contactName: 'Test Inquiry',
    contactInitials: 'TI',
    avatarColor: '#E07B54',
    lastMessage: 'Hi Test, our appointment is in 10 min...',
    lastMessageTime: 'Jun 06',
    unreadCount: 0,
    isStarred: true,
    channel: 'email',
  },
];

// ============================================================================
// Mock Messages (for conversation conv-1)
// ============================================================================

export const MOCK_MESSAGES: IMessage[] = [
  {
    id: 'msg-1',
    conversationId: 'conv-1',
    sender: 'lead',
    senderName: 'Keven Text',
    senderInitials: 'KT',
    avatarColor: '#B8EF70',
    text: "Alright, let's get you scheduled for a tour at 123 Doodoo Lane. How about today at 7:30 PM or tomorrow at 9 AM?",
    timestamp: '04:20 PM',
    isOutgoing: false,
  },
  {
    id: 'msg-2',
    conversationId: 'conv-1',
    sender: 'agent',
    senderName: 'You',
    senderInitials: 'PB',
    avatarColor: '#B8EF70',
    text: '9am works!',
    timestamp: '04:20 PM',
    isOutgoing: true,
  },
  {
    id: 'msg-3',
    conversationId: 'conv-1',
    sender: 'agent',
    senderName: 'You',
    senderInitials: 'PB',
    avatarColor: '#B8EF70',
    text: 'Can we tour some homes?',
    timestamp: '04:30 PM',
    isOutgoing: true,
  },
  {
    id: 'msg-4',
    conversationId: 'conv-1',
    sender: 'lead',
    senderName: 'Keven Text',
    senderInitials: 'KT',
    avatarColor: '#B8EF70',
    text: 'Absolutely! Before we set up a tour, could you share your name with me? 😊',
    timestamp: '04:32 PM',
    isOutgoing: false,
  },
];

// ============================================================================
// Mock Contact Details
// ============================================================================

export const MOCK_CONTACT: IContactDetail = {
  id: 'contact-1',
  name: 'Keven Text',
  initials: 'KT',
  avatarColor: '#B8EF70',
  contactType: 'Buyer',
  contactTypeColor: '#0D9488',
  email: 'keven@example.com',
  phone: '+1 (555) 123-4567',
  assignedTo: 'Paul B.',
};

// ============================================================================
// Mock Tags
// ============================================================================

export const MOCK_TAGS: IContactTag[] = [
  {
    id: 'tag-1',
    label: 'Hot Lead',
    color: '#EF4444',
    bgColor: '#EF444420',
  },
  {
    id: 'tag-2',
    label: 'Tour Scheduled',
    color: '#B8EF70',
    bgColor: '#B8EF7020',
  },
];

